<template>
  <div class="article-layout" v-if="currentArticle">
    <div class="wrapper">
      <AppBackButton :linkMode="true" to="/article"></AppBackButton>
    </div>
    <PageTitle :title="t('article')" />

    <div class="wrapper">
      <transition name="slide-from-right" mode="out-in">
        <div class="n-program-overview">
          <div v-if="currentArticle">
            <AppTitle mode="h2">
              <template v-slot:title>{{ currentArticle.title }}</template>
            </AppTitle>
            <div class="n-program-overview__content">

              <div class="salon-data" v-html="currentArticle.newsContent"></div>

              <div v-if="currentArticle.videoFiles && currentArticle.videoFiles.length">
                   <h2 class="mt-4 pa-4">Видео:</h2>
                <ArticleVideoPreview
                class="ma-2"
                  v-for="(e, idx) in currentArticle.videoFiles"
                  :key="idx"
                  :videoFile="e"
                  @selectVideo="selectVideo"
                />
              </div>

               <div class="ma-2" v-if="currentArticle.experts && currentArticle.experts.length">
                                 <h2 class="mt-4 pa-4" v-if="currentArticle.experts.length>1">Эксперты:</h2>
                                 <h2 class="mt-4 pa-4" v-else>Эксперт:</h2>
                              <ExpertCard
                                v-for="(e, idx) in sortedExperts"
                                :key="idx"
                                :expert="e"

                              />
                            </div>

                            <div v-if="currentArticle.newsTags && currentArticle.newsTags.length>0" class="ma-2">
                                          <h2 class="mt-4 pa-4">Ярлыки:</h2>
                                          <div class="help-page__chips">
                                            <span v-for="c in currentArticle.newsTags" :key="c.id">{{c.tagName}}</span>
                                          </div>
                                        </div>

              <SalonMetaData :data="{ date: currentArticle.publDateTime }" class="ma-6"/>
              <v-divider class="mt-2 mb-2"></v-divider>

              <div v-if="currentArticle.sourceUrl" class="ma-6">
                <strong><a target="blank" :href="currentArticle.sourceUrl">Источник</a></strong>
              </div>
            </div>
          </div>
          <LoaderRing v-else />
        </div>
      </transition>
    </div>

    <NVideoModal
      v-if="showVideo"
      :video="video"
      @closeModal="closeVideoModal"
    />
  </div>
</template>

<script>
  import { t } from "@/utils/translate";
  import { onMounted, computed } from "vue";
  import { ref } from "vue";
  import { customAxios } from "@/service/customAxios";
  import { useRoute } from "vue-router";
  import PageTitle from "@/elements/PageTitle.vue";
  import AppBackButton from "@/elements/AppBackButton.vue";
  import AppTitle from "@/elements/AppTitle.vue";
  import LoaderRing from "@/elements/LoaderRing.vue";
  import NVideoModal from "@/components/NVideoModal.vue";
  import SalonMetaData from "@/components/SalonMetaData.vue";
  import ArticleVideoPreview from "@/components/ArticleVideoPreview.vue";
  import ExpertCard from "@/components/ExpertCard.vue"

  export default {
    components: {
      NVideoModal,
      LoaderRing,
      AppBackButton,
      PageTitle,
      AppTitle,
      SalonMetaData,
      ArticleVideoPreview,
      ExpertCard
    },
    setup() {
      const currentArticle = ref("");
      const menuIsShowed = ref(false);
      const route = useRoute();
      const video = ref('');
      const showVideo = ref(false);
      
      function closeVideoModal() {
        showVideo.value = false;
        video.value = null;
      }
      
      function selectVideo(v) {
        video.value = v;
        showVideo.value = true;
      }

      async function getArticleData() {
        try {
          const r = await customAxios.get(`news/published/${route.params.id}`);
          currentArticle.value = r.data;
        } catch (e) {
          console.log(e);
        }
      }

      onMounted(async () => {
        await getArticleData();
      });
      
      function formatDate(dateString) {
        let formatter = new Intl.DateTimeFormat("ru", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });

        return capitalizeFirstLetter(formatter.format(Date.parse(dateString)));
      }
      
      function capitalizeFirstLetter(string) {
        if (string && string.length > 0) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
          return ''
        }
      }

      const sortedExperts = computed(() => {
        if (!currentArticle.value || !currentArticle.value.experts || !Array.isArray(currentArticle.value.experts)) {
          return [];
        }
        return [...currentArticle.value.experts].sort((a, b) => {
          const lastNameA = a.lastname || '';
          const lastNameB = b.lastname || '';
          return lastNameA.localeCompare(lastNameB);
        });
      });
      
      return {
        t,
        menuIsShowed,
        currentArticle,
        formatDate,
        video,
        showVideo,
        closeVideoModal,
        selectVideo,
        sortedExperts
      };
    },
  };
  </script>
  <style lang="scss">

    .ql-align-center{
        margin:0 auto;
        display: flex;
        justify-content: center;
    }
    ol {
        list-style-type: none;
        counter-reset: num;
        margin: 0 0 0 35px;
        padding: 15px 0 5px 0;
        font-size: 18px;
    }

    p {
        margin-bottom: 0 }
    p + p {
        text-indent: 1.5em;
        margin-top: 0
    }
    blockquote {
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 30px;
        padding-left: 15px;
        border-left: 4px solid $main-2;
        text-align: justify;
        font-size: 1.25em;
}

  .article-layout {
    &__wrapper {
      @include page;
    }
  }
  .salon-data {
    text-align: center;
  }

  .salon-data ul {

    padding: 10px !important;
    margin-left: 40px;
    text-align: justify;
  }

  .salon-data li {
    padding-top: 20px !important;
    text-align: justify;
  }

  .salon-data p {
    padding-left: 20px !important;
    text-align: justify;
  }
  .salon-data h1 {
    padding-bottom: 40px !important;
    padding-top: 40px !important;
    text-align: center;
  }
  .salon-data h2 {
    padding-bottom: 40px !important;
    padding-top: 40px !important;
    text-align: center;
  }

  .salon-data h3 {
    padding-bottom: 40px !important;
    padding-top: 40px !important;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
  }

  .salon-data h4 {
    padding-bottom: 40px !important;
    padding-top: 40px !important;
    text-align: center;
  }

  .salon-data h5 {
    padding-bottom: 40px !important;
    padding-top: 40px !important;
    text-align: center;
  }

  .salon-data  img {
    max-width: 80% !important;
    margin: auto;
    display: block;
  }


  .salon-data ::v-deep blockquote {
    padding: 15px;
    background: #eee;
    border-radius: 5px;
  }

  .salon-data ::v-deep blockquote p {
    padding: 15px;
    background: #eee;
    border-radius: 5px;
  }

  .salon-data ::v-deep blockquote::after {
    content: "\201C";
  }

  .salon-data ::v-deep blockquote::before {
    content: "\201D";
  }

  .salon-data ::v-deep pre {
    padding: 15px;
    background: rgba(104, 99, 255, 0.96);
    color: rgb(255, 255, 255);
    border-radius: 5px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  </style>
  